export const IMPORT_COURSE = "import_course";
export const UPDATE_COURSE = "update_course";
export const CURR_COURSEWARE = "curr_courseware";